;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import SignupWithEmail from './SignupWithEmail';
import LoginWithProvider from './LoginWithProvider';
import { getI18nUtils } from '../../i18n/i18n-utils';
import { Dictionaries } from '../../i18n/i18n-config';

type Props = {
  emailAddress?: string;
  dictionary: Partial<Dictionaries>;
};

function Signup({ emailAddress, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <div id="loginContainer">
      <SignupWithEmail dictionary={dictionary} emailAddress={emailAddress} />
      <div className="position-relative my-3">
        <hr className="position-absolute w-100" style={{ top: '4px', zIndex: -1 }} />
        <div className="d-block mx-auto bg-white px-4 py-2" style={{ width: 'fit-content' }}>
          {formatMessage({ id: 'login-continue-with' })}
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center my-3">
        <LoginWithProvider dictionary={dictionary} centerButtons />
      </div>
    </div>
  );
}

export default Signup;
